import React from "react"
import {
    CreateRepresentativeRequest,
    JobType,
    Representative
} from "../../../models";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Grid,
    Typography
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {t, Trans} from "@lingui/macro";
import {
    MatesSelect,
    MatesTextField,
    withUseFormHook
} from "@sinossi/mates-react-library";
import {UseFormReturn} from "react-hook-form";
import RepresentativesValidation from "./form"

interface RepresentativesProps extends UseFormReturn {
    representativeList: Representative[]
    submitRepresentative: (rep: CreateRepresentativeRequest) => void
}

interface RepresentativesState {
    isLoading: boolean
}

class Representatives extends React.Component<RepresentativesProps, RepresentativesState> {

    constructor(props: RepresentativesProps) {
        super(props);
        this.state = {
            isLoading: true
        }
    }

    componentDidMount() {
        this.props.representativeList.map((rep) => this.fillForm(rep))
        this.setState(() => ({
            isLoading: false
        }))
    }

    private fillForm = (rep: Representative) => {
        this.props.setValue("representative-" + rep.id, rep.name)
        this.props.setValue("email-" + rep.id, rep.email)
        this.props.setValue("phone-" + rep.id, rep.phone)
        this.props.setValue("job-" + rep.id, rep.job)
    }

    private submitForm = (rep: CreateRepresentativeRequest) => {
        const request: CreateRepresentativeRequest = {
            id: rep.id,
            name: this.props.getValues("representative-" + rep.id),
            email: this.props.getValues("email-" + rep.id),
            phone: this.props.getValues("phone-" + rep.id),
            job: this.props.getValues("job-" + rep.id)
        }

        this.props.submitRepresentative(request)
    }

    render(){
        const jobOptions = Object.values(JobType).map((job: any) => (
            <option key={job} value={job}>
                <Trans id = {`enums.representative-job.${job}`}>
                </Trans>
            </option>
        ))
        return (
            <>
                {
                    !this.state.isLoading && this.props.representativeList.map((rep) =>
                    <Box key={rep.id} mt={1}>
                        <Accordion sx={{
                            border: 1,
                            borderColor: 'primary.main',
                            '& .MuiAccordionSummary-root': {
                                flexDirection: 'row-reverse', // Align icon to the left
                            }
                        }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={"panel-content-" + rep.id}
                                id={"panel-header-" + rep.id}
                            >
                                <Typography sx={{ml: "12px"}}>
                                    <Trans id={"brand-profile.representatives.accordion-title." + rep.id}>{rep.name}</Trans>
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <form onSubmit={this.props.handleSubmit(() => this.submitForm(rep))}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <MatesTextField
                                                variant={"outlined"}
                                                label={t({
                                                    id: "brandProfile.representative." + rep.id,
                                                    message: "Referente",
                                                })}
                                                name={"representative-" + rep.id}
                                                control={this.props.control}
                                                trigger={this.props.trigger}
                                                formState={this.props.formState}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <MatesTextField
                                                variant={"outlined"}
                                                label={t({
                                                    id: "brandProfile.email." + rep.id,
                                                    message: "Email",
                                                })}
                                                name={"email-" + rep.id}
                                                control={this.props.control}
                                                trigger={this.props.trigger}
                                                formState={this.props.formState}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <MatesTextField
                                                variant={"outlined"}
                                                label={t({
                                                    id: "brandProfile.phone." + rep.id,
                                                    message: "Telefono",
                                                })}
                                                name={"phone-" + rep.id}
                                                control={this.props.control}
                                                trigger={this.props.trigger}
                                                formState={this.props.formState}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <MatesSelect
                                                variant={"outlined"}
                                                label={t({
                                                    id: "brandProfile.job." + rep.id,
                                                    message: "Ruolo",
                                                })}
                                                name={"job-" + rep.id}
                                                control={this.props.control}
                                                trigger={this.props.trigger}
                                                formState={this.props.formState}
                                            >
                                                {jobOptions}
                                            </MatesSelect>
                                        </Grid>
                                    </Grid>
                                    <Box textAlign={"right"} sx={{mt: 2}}>
                                        <Button
                                            variant="contained"
                                            type={"submit"}
                                            disableElevation
                                            sx={{
                                                textTransform: 'none',
                                                backgroundColor: 'secondary.main',
                                                color: 'white',
                                                paddingX: 5,
                                            }}>
                                            <Typography>
                                                <Trans id="sf-ticket-submit-button">
                                                    Salva
                                                </Trans>
                                            </Typography>
                                        </Button>
                                    </Box>
                                </form>
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                    )
                }
            </>
        )
    }
}

export default withUseFormHook<{}>(
    Representatives,
    RepresentativesValidation,
    {}
)
